import { render, staticRenderFns } from "./RelatorioResumidoDespesaGeralFiltros.vue?vue&type=template&id=212254a6"
import script from "./RelatorioResumidoDespesaGeralFiltros.vue?vue&type=script&lang=js"
export * from "./RelatorioResumidoDespesaGeralFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports